var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-ProductCard_FastShippingLabel"},[_vm._v("\n  当日・翌日出荷\n")])}
var staticRenderFns = []

export { render, staticRenderFns }